<template>
  <div class="content max-w-screen-3xl">
    <h1>Candles</h1>
    <div class="flex flex-col gap-4">
      <div>
        <div class="flex justify-between gap-4">
          <div class="flex gap-4 items-center w-full">
            <div class="flex gap-2 items-center w-full">
              <div>
                <b-form-select
                  v-model="filters.candle_status"
                  :options="options.candle_status"
                  size="sm"
                  style="width: 130px !important;"
                  @input="scheduleFetching"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      Status
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </div>

              <div>
                <v-select
                  v-model="filters.competitor_brand_id"
                  :options="dropdowns.competitor_brand"
                  size="sm"
                  label="text"
                  :reduce="option => option.value"
                  appendToBody
                  :calculatePosition="calculatePosition"
                  placeholder="Brand"
                  style="width: 180px !important;"
                  @input="scheduleFetching"
                />
              </div>

              <b-form-input
                v-model="filters.search"
                size="sm"
                class="w-full max-w-sm"
                autocomplete="off"
                @input="scheduleFetching"
                placeholder="Search by text"
                type="search"
              ></b-form-input>
            </div>
          </div>

          <div class="flex gap-2 items-center">
            <b-btn
              size="sm"
              variant="primary"
              @click="createCandle"
            >
              New
            </b-btn>
          </div>

        </div>
      </div>

      <div v-if="records" class="font-bold">
        Showing {{ records.length | format }} / {{ recordCount | format }} candle(s)
      </div>

      <table v-if="records" class="table table-google table-highlight w-100">
        <thead>
          <tr>
            <th>Status</th>
            <th>Brand</th>
            <th>Name</th>
            <th>Fragrance</th>
            <th>Size</th>
            <th>Created</th>
            <th>Updated</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="record in records" :key="record.id">
            <td class="row-fit">
              <status-badge :status="record.candle_status" />
            </td>
            <td>{{ record.competitor_brand_text }}</td>
            <td>{{ record.candle_name }}</td>
            <td>{{ record.candle_fragrance }}</td>
            <td>{{ record.candle_size }}</td>
            <td class="row-fit">{{ record.create_date | isodate }}</td>
            <td class="row-fit">{{ record.update_date | isodate }}</td>
            <td class="row-fit">
              <router-link :to="`/competitors/${record.id}`" class="btn btn-sm btn-primary">
                View
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-pagination
      v-model="filters.page"
      :total-rows="recordCount"
      :per-page="filters.per_page"
      @change="paginate"
      :disabled="isLoading"
      class="mt-4"
    ></b-pagination>
  </div>
</template>

<script>
import { calculateDropdownPosition } from '@/helpers';

const _ = require('lodash');

const StatusBadge = () => import('@/components/competitor/StatusBadge.vue');

export default {
  name: 'Competitors',
  components: {
    StatusBadge,
  },
  computed: {
    isLoading() {
      return this.loadingCount > 0;
    },
    dropdowns() {
      return this.$store.state.app.dropdowns;
    },
  },
  data() {
    return {
      loadingCount: 0,
      records: null,
      recordCount: 0,
      scheduleFetching: _.debounce(() => {
        this.fetchRecords();
      }, 500),
      filters: {
        page: 1,
        per_page: 50,
        search: '',
        competitor_brand_id: null,
        candle_status: null,
      },
      options: {
        candle_status: [
          { text: 'All', value: null },
          { text: 'New', value: 'new' },
          { text: 'Burning', value: 'burning' },
          { text: 'Finished', value: 'finished' },
        ],
      },
    };
  },
  methods: {
    createCandle() {
      this.loadingCount++;
      this.$http
        .post('/competitors')
        .then((res) => {
          this.$router.push(`/competitors/${res.body}`);
        })
        .catch((err) => {
          this.$toast.error(`Failed to create record: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    paginate() {
      this.$nextTick().then(() => {
        this.fetchRecords(true);
      });
    },
    fetchRecordData() {
      this.loadingCount++;
      this.$http
        .get('/competitors')
        .query(this.filters)
        .then((res) => {
          this.records = res.body;
        })
        .catch((err) => {
          this.$toast.error(`Failed to fetch records: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    fetchRecordCount() {
      this.loadingCount++;
      this.$http
        .get('/competitor_count')
        .query(this.filters)
        .then((res) => {
          this.recordCount = res.body;
        })
        .catch((err) => {
          this.$toast.error(`Failed to fetch record count: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    fetchRecords(paginate) {
      paginate = paginate === undefined ? false : paginate;
      if (paginate === false) {
        this.fetchRecordCount();
      } else {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 50);
      }
      this.fetchRecordData();
    },
    fetchAll() {
      this.fetchRecords();
    },
    calculatePosition(dropdownList, component) {
      return calculateDropdownPosition(dropdownList, component);
    },
  },
  created() {
    this.fetchAll();
  },
};
</script>

<style lang="scss" scoped>
</style>
